import logoSrc from 'images/branding/avtodor/aeroinspector1.png'
import Footer from './Footer'
import style from './AvtodorLayout.module.css'

const AvtodorLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className={style.wrapper}>
      <div className={style.name}>
        <img className={style.logoImg} src={logoSrc} alt="logo" />
        <p>Сервис по мониторингу объектов строительства</p>
      </div>
      {children}
      <div className={style.description}>Контроль строительства на новой высоте</div>
      <Footer />
    </div>
  )
}

export default AvtodorLayout
